import { render, staticRenderFns } from "./RecurringRemarkView.vue?vue&type=template&id=4f4d5ebd"
import script from "./RecurringRemarkView.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports